// @core/api/endpoints/bootstrap/validate_slug.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateSlugResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Validate platform slug
 * Checks if a platform slug is valid and available.
 * @public This endpoint does not require authentication
 */
export async function ValidateSlug(
  params?: {
    slug?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ValidateSlugResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/validate/slug`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ValidateSlugResponse>(requestPath, { ...requestOptions, params });
}
